if (process.env.NODE_ENV !== 'development') {
  __webpack_public_path__ = window.__CHATBOX_CDN
}
